import { useBudouX } from "@/hooks/useBudouX";

const specsLeft = [
  {
    section: "基本機能",
    list: [
      {
        title: "ページ情報管理機能",
        body: "ページの管理・編集・追加が行えます",
      },
      {
        title: "テンプレート管理機能",
        body: "ページの共通部分をテンプレートとして管理・編集・追加が行えます",
      },
      {
        title: "部品管理機能",
        body: "ページテンプレートより細かい共通部分を部品として管理・編集・追加が行えます",
      },
      {
        title: "スタイルシート管理機能",
        body: "スタイルシートを動的に管理・編集・追加が行えます",
      },
      {
        title: "スクリプト管理機能",
        body: "スクリプトを動的に管理・編集・追加が行えます",
      },
      {
        title: "ファイル管理機能",
        body: "Web で使用するファイルをブラウザ上で管理が行えます",
      },
    ],
  },
  {
    section: "ワークフロー機能",
    list: [
      {
        title: "ワークフロー設定機能",
        body: "ワークフローの設定が行えます",
      },
      {
        title: "ワークフローアクション定義機能",
        body: "ワークフローアクションルートやアクション内容などの定義が行えます",
      },
      {
        title: "ワークフローアクション状態定義機能",
        body: "ワークフローアクション時の状態の定義が行えます",
      },
      {
        title: "ワークフローアクション通知機能",
        body: "ワークフローアクションにおける通知設定が行えます",
      },
    ],
  },
  {
    section: "その他機能",
    list: [
      {
        title: "選択肢（値）管理機能",
        body: "各種選択肢（値）の管理が行えます",
      },
      {
        title: "ドメイン管理設定機能",
        body: "使用するドメインの設定が行えます",
      },
      {
        title: "フォルダ管理設定機能",
        body: "使用するフォルダの設定が行えます",
      },
      {
        title: "特殊ページ設定機能",
        body: "特殊ページ（NotFound/Forbidden/Unauthorized）の設定が行えます",
      },
      {
        title: "内部SEO対策",
        body: "内部SEO対策を踏まえたコード、XMLサイトマップの生成を行います",
      },
      {
        title: "Speed関数",
        body: "Speed関数が利用できます",
      },
      {
        title: "データテーブル",
        body: "データテーブルが利用できます",
      },
      {
        title: "シングルサインオン連携",
        body: "【オプション】他システムとのシングルサインオン連携を行います",
      },
    ],
  },
  {
    section: "インテグレーションサポートメニュー",
    list: [
      {
        title: "コンテンツ移行",
        body: "静的コンテンツや他CMSからの移行インテグレーション",
      },
      {
        title: "外部SEO対策",
        body: "SNSなどを駆使した総合的なSEOインテグレーション",
      },
      {
        title: "マルチデバイス/レスポンシブ対応",
        body: "マルチデバイス対応のレスポンシブサイト構築インテグレーション",
      },
      {
        title: "アクセシビリティガイドライン対応",
        body: "アクセシビリティガイドラインに対応するサイト構築インテグレーション",
      },
    ],
  },
];
const specsRight = [
  {
    section: "ユーザー管理機能",
    list: [
      {
        title: "ユーザー管理機能",
        body: "ユーザーの管理が行えます",
      },
      {
        title: "ユーザー権限設定機能",
        body: "ユーザーに対し権限の割り当てが行えます",
      },
      {
        title: "ユーザーグループ管理機能",
        body: "ユーザーをグループで管理できます",
      },
      {
        title: "ユーザーグループ権限設定機能",
        body: "ユーザーグループに対し権限の割り当てが行えます",
      },
    ],
  },
  {
    section: "情報発信機能",
    list: [
      {
        title: "指定時間公開機能",
        body: "時間を指定してコンテンツを公開できます",
      },
      {
        title: "公開期限設定機能",
        body: "時間を指定してコンテンツ公開を終了できます",
      },
      {
        title: "世代管理機能",
        body: "同一コンテンツに対し複数世代の管理が行えます",
      },
      {
        title: "スケジュール管理機能",
        body: "スケジュールされた時間でコンテンツの公開・終了が行えます（要cron）",
      },
      {
        title: "アーカイブ機能",
        body: "操作（公開もしくは保存）に応じ、コンテンツのアーカイブが行えます",
      },
      {
        title: "プレビュー機能",
        body: "ページのプレビューが行えます",
      },
      {
        title: "リッチテキストエディタ機能",
        body: "リッチテキストエディタ（WYSIWYG）エディタでのページ編集が行えます",
      },
      {
        title: "エディタカスタマイズ機能",
        body: "SpeedCMS標準エディタ以外のエディタへカスタマイズが行えます",
      },
      {
        title: "XMLサイトマップ生成機能",
        body: "XMLサイトマップを動的に生成します",
      },
      {
        title: "HTML METAコード編集機能",
        body: "METAコード（キーワード/説明文/作成者情報）の編集、HEADコード（HTML属性/HEAD属性/BODY属性/HEADコード）の編集が行えます",
      },
    ],
  },
  {
    section: "業務特化型拡張テンプレート",
    list: [
      {
        title: "お知らせ管理テンプレート",
        body: "お知らせコンテンツ拡張管理テンプレート",
      },
      {
        title: "お問い合わせ管理テンプレート",
        body: "お問い合わせコンテンツ拡張管理テンプレ―ト",
      },
      {
        title: "サイト内検索テンプレート",
        body: "サイト内検索拡張テンプレ―ト",
      },
      {
        title: "SNS連携テンプレート",
        body: "SNS（twitter/Facebook）連携を行うための拡張テンプレート",
      },
      {
        title: "ブログサービステンプレート",
        body: "ブログサービスを行うための拡張テンプレート",
      },
      {
        title: "アンケートテンプレート",
        body: "ユーザーアンケートなどを行うための拡張テンプレート",
      },
      {
        title: "資料請求テンプレート",
        body: "ユーザーからの資料請求・ダウンロードなどを行うための拡張テンプレート",
      },
      {
        title: "予約管理テンプレ―ト",
        body: "ユーザーからの予約受付・管理を行うための拡張テンプレート",
      },
      {
        title: "EC（物販）テンプレート",
        body: "物販向けECを行うための拡張テンプレート",
      },
      {
        title: "EC（電子コンテンツ）テンプレート",
        body: "電子コンテンツECを行うための拡張テンプレート",
      },
      {
        title: "XMLサイトマップ生成機能",
        body: "XMLサイトマップを動的に生成します",
      },
    ],
  },
];

export const SpeedCmsSpec = (props) => {
  const { parse } = useBudouX();
  return (
    <div className="pb-5 md:pb-16">
      <h3 className="w-full font-bold text-sec fluid-text-[11px,18px]">
        Spec of SpeedCMS
      </h3>
      <div className="flex w-full flex-col gap-y-5 fluid-text-[14px,18px] md:flex-row md:gap-x-10 md:gap-y-20">
        <div className="flex flex-1 flex-col gap-5 md:gap-10">
          {specsLeft.map((spec) => (
            <dl
              key={spec.section}
              className="col-span-1 max-w-full space-y-2 md:space-y-6 "
            >
              <dt className="flex flex-row items-center gap-2 font-bold text-ter fluid-text-[16px,22px]">
                <h3>{spec.section}</h3>
              </dt>
              <dd className="leading-comfort text-txt-base">
                {spec.list && (
                  <div className="mt-2 flex flex-col gap-2 md:gap-1">
                    {spec.list.map(function (item) {
                      return (
                        <dl key={item.index}>
                          <dt className="font-bold text-pri">{item.title}</dt>
                          <dd className=" fluid-text-[12px,16px]">
                            {item.body}
                          </dd>
                        </dl>
                      );
                    })}
                  </div>
                )}
              </dd>
            </dl>
          ))}
        </div>
        <div className="flex flex-1 flex-col gap-5 md:gap-10">
          {specsRight.map((spec) => (
            <dl
              key={spec.section}
              className="col-span-1 max-w-full space-y-2 md:space-y-6 "
            >
              <dt className="flex flex-row items-center gap-2 font-bold text-ter fluid-text-[16px,22px]">
                <h3>{spec.section}</h3>
              </dt>
              <dd className="leading-comfort text-txt-base">
                {spec.list && (
                  <div className="mt-2 flex flex-col gap-2 md:gap-1">
                    {spec.list.map(function (item) {
                      return (
                        <dl key={item.index}>
                          <dt className="font-bold text-pri">{item.title}</dt>
                          <dd className=" fluid-text-[12px,16px]">
                            {item.body}
                          </dd>
                        </dl>
                      );
                    })}
                  </div>
                )}
              </dd>
            </dl>
          ))}
        </div>
      </div>
    </div>
  );
};
